<template>
  <div>

    <div class="register-products-nav container-fluid">
      <div class="row">
        <div class="offset-1 col-10  offset-xl-1 col-xl-10">
          <div class="row">
            <div class="tab-cnt col-lg-4" style="padding-left: 0px;">
              <div class="nav-inner active" v-html="$t('common.nav_step1')"></div>
            </div>
            <div class="tab-cnt col-lg-4 d-none d-lg-block">
              <div class="nav-inner" v-html="$t('common.nav_step2')"></div>
            </div>
            <div class="tab-cnt col-lg-4 d-none d-lg-block" style="padding-right: 0px;">
              <div class="nav-inner" v-html="$t('common.nav_step3')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="offset-1 col-10 register-products">
          <div class="row justify-content-center">
            <div class="col-10">
              <h2 class="register-products__heading">{{ $t('step1.heading') }}</h2>

              <div class="row">
                <div class="col-xs-12 col-lg-6 form-group">
                  <label for="userFirstName">{{ $t('step1.first_name') }}:</label>
                  <input v-model="formData.first_name" type="text" class="form-control" id="userFirstName" name="userFirstName" :placeholder="$t('step1.first_name')" v-validate="'required'">
                  <small>{{ errors.first('userFirstName') }}</small>
                </div>
                <div class="col-xs-12 col-lg-6 form-group">
                  <label for="userLastName">{{ $t('step1.last_name') }}:</label>
                  <input v-model="formData.last_name" type="text" class="form-control" id="userLastName" name="userLastName" :placeholder="$t('step1.last_name')" v-validate="'required'">
                  <small>{{ errors.first('userLastName') }}</small>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 col-lg-6 form-group">
                  <label for="userStreet">{{ $t('step1.street') }}:</label>
                  <input v-model="formData.street" type="text" class="form-control" id="userStreet" name="userStreet" :placeholder="$t('step1.street')" v-validate="'required'">
                  <small>{{ errors.first('userStreet') }}</small>
                </div>
                <div class="col-xs-12 col-lg-3 form-group">
                  <label for="houseNumber">{{ $t('step1.house_number') }}:</label>
                  <input v-model="formData.house_number" type="text" class="form-control" id="houseNumber" name="houseNumber" :placeholder="$t('step1.house_number')" v-validate="'required'">
                  <small>{{ errors.first('houseNumber') }}</small>
                </div>
                <div class="col-xs-12 col-lg-3 form-group">
                  <label for="flatNumber">{{ $t('step1.flat_number') }}:</label>
                  <input v-model="formData.flat_number" type="text" class="form-control" id="flatNumber" name="flatNumber" :placeholder="$t('step1.flat_number')">
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 col-lg-8 form-group">
                  <label for="userCity">{{ $t('step1.city') }}:</label>
                  <input v-model="formData.city" type="text" class="form-control" id="userCity" name="userCity" :placeholder="$t('step1.city')" v-validate="'required'">
                  <small>{{ errors.first('userCity') }}</small>
                </div>
                <div class="col-xs-12 col-lg-4 form-group">
                  <label for="userZipCode">{{ $t('step1.zip_code') }}:</label>
                  <input v-model="formData.zip_code" type="text" class="form-control" id="userZipCode" name="userZipCode" :placeholder="$t('step1.zip_code')">
                  <small>{{ errors.first('userZipCode') }}</small>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 col-lg-6 form-group">
                  <label for="userPhone">{{ $t('step1.phone_number') }}:</label>
                  <input v-model="formData.phone" type="text" class="form-control" id="userPhone" name="userPhone" v-validate="'required'">
                  <small>{{ errors.first('userPhone') }}</small>
                </div>
                <div class="col-xs-12 col-lg-6 form-group">
                  <label for="userEmail">{{ $t('step1.email') }}:</label>
                  <input v-model="formData.email" type="text" class="form-control" id="userEmail" name="userEmail" :placeholder="$t('step1.email')" v-validate="'required|email'">
                  <small>{{ errors.first('userEmail') }}</small>
                </div>
              </div>

              <div class="row">

                <div class="col-12 terms">
                  <p style="margin-top: 20px; background: #dedede; padding: 10px; text-align: center; font-size: 16px; ">
                    <strong>{{ $t('step1.agreements_main_heading') }}</strong>
                  </p>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label class="form-check-label" for="main_agreement">
                        <input v-model="main_agreement" type="checkbox" name="main_agreement" class="agreement_checkbox" id="main_agreement" v-validate="'required'">
                        * {{ $t('step1.main_agreement') }}
                      </label>
                      <small class="form-text">{{ errors.first('main_agreement') }}</small>
                    </div>
                  </div>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label for="main_agreement_2">
                        <input v-model="formData.terms_agreement" type="checkbox" name="main_agreement_2" class="agreement_checkbox" id="main_agreement_2" v-validate="'required'">
                        * {{ formData.terms_agreement_text }}
                      </label>
                      <small class="form-text">{{ errors.first('main_agreement_2') }}</small>
                    </div>
                  </div>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label for="main_agreement_3">
                        <input v-model="formData.main_agreement_3" type="checkbox" name="main_agreement_3" class="agreement_checkbox" id="main_agreement_3" v-validate="'required'">
                        * <span v-html="formData.main_agreement_3_text"></span>
                      </label>
                      <small class="form-text">{{ errors.first('main_agreement_3') }}</small>
                    </div>
                  </div>

                  <p v-html="$t('step1.agreements_danger')"></p>

                  <p style="margin-top: 20px; background: #dedede; padding: 10px; text-align: center; font-size: 16px; ">
                    <strong>{{ $t('step1.agreements_marketing_heading') }}</strong>
                  </p>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label for="electronic_agreement">
                        <input v-model="formData.electronic_agreement" type="checkbox" name="electronic_agreement" class="agreement_checkbox" id="electronic_agreement">
                        {{ formData.electronic_agreement_text }}
                      </label>
                    </div>
                  </div>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label for="marketing_agreement">
                        <input v-model="formData.marketing_agreement" type="checkbox" name="marketing_agreement" class="agreement_checkbox" id="marketing_agreement">
                        {{ formData.marketing_agreement_text }}
                      </label>
                    </div>
                  </div>

                  <div class="term__group">
                    <div class="form-group legal-group">
                      <label for="agreement_new">
                        <input v-model="formData.agreement_new" type="checkbox" name="agreement_new" class="agreement_checkbox" id="agreement_new">
                        {{ formData.agreement_new_text }}
                      </label>
                    </div>
                  </div>

                  <p style="margin-top: 20px; background: #dedede; padding: 10px; text-align: center; font-size: 16px; ">
                    <strong>{{ $t('step1.agreements_info_heading') }}</strong>
                  </p>

                  <div class="term__group">
                    <div class="form-group legal-group" v-html="$t('step1.agreements_info')"></div>
                  </div>

                </div>

              </div>

              <div class="row">
                <div class="col form-group text-right">
                  <button @click.prevent="submitForm()" class="amica-btn amica-btn-red btn-next-step">{{ $t('common.btn_next_step') }}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MaskedInput from 'vue-masked-input'

export default {
  name: 'RegisterStep1',
  data () {
    return {
      main_agreement: false,
      formData: {
        email: '',
        first_name: '',
        last_name: '',
        street: '',
        house_number: '',
        flat_number: '',
        city: '',
        zip_code: '',
        phone: '',
        terms_agreement: false,
        terms_agreement_text: this.$t('step1.terms_agreement'),
        main_agreement_3: false,
        main_agreement_3_text: this.$t('step1.main_agreement_3'),
        electronic_agreement: false,
        electronic_agreement_text: this.$t('step1.electronic_agreement'),
        marketing_agreement: false,
        marketing_agreement_text: this.$t('step1.marketing_agreement'),
        agreement_new: false,
        agreement_new_text: this.$t('step1.agreement_new'),
      }
    }
  },
  mounted () {
    this.restoreForm();
  },
  methods: {
    restoreForm: function () {
      console.log(this.$store.getters.getUserData);
      if (this.$store.getters.getUserData.email) {
        this.formData = this.$store.getters.getUserData
      }
    },
    submitForm: function () {
      let cmp = this
      this.$validator.validateAll().then((formIsValid) => {
        if (formIsValid) {
          cmp.$store.dispatch('applyUserData', this.formData).then(() => {
            cmp.$store.dispatch('setRegistrationInProgress')
            this.$router.push('/product-registration/step-2')
          }).catch((error) => {
            console.error('Nie udało się zapisać danych w pamięci przeglądarki')
            console.log(error)
          })
        }
      })
    }
  },
  components: {
    MaskedInput
  }
}
</script>

<style lang="scss" scoped>

  .form-group {
    input[type="checkbox"] {
      margin-right: 5px;
    }
  }

  .register-products-nav {
    margin-top: 60px;

    .nav-inner {
      width: 100%;
      padding: 20px 0;
      font-size: 16px;
      text-align: center;
      text-transform: uppercase;
      background: #ececec;
      opacity: 0.6;

      position: relative;
      z-index: 1;
      margin-bottom: -1px;

      border: 1px #dedede solid;
      border-radius: 10px 10px 0px 0px;
      -moz-border-radius: 10px 10px 0px 0px;
      -webkit-border-radius: 10px 10px 0px 0px;

      @media only screen and (max-width : 1199px) {
        font-size: 13px;
      }

      @media only screen and (max-width : 991px) {
        font-size: 16px;
      }

      &.active {
        border-bottom: 1px #fff solid;
        background: #fff;
        opacity: 1;
      }

      & /deep/ span {
        color: #e41429;
        font-weight: 900;
      }
    }

    .tab-cnt {
      @media only screen and (max-width : 991px) {
        padding-right: 0px;
      }
    }
  }

  .register-products {
    border: 1px #dedede solid;
    padding-top: 50px;
    padding-bottom: 20px;

    .register-products__heading {
      color: #000;
      font-size: 38px;
      font-weight: 300;
      margin-bottom: 50px;
    }

    .btn-next-step {
      padding-left: 40px;
      padding-right: 40px;

    }
  }

  .terms {
    font-size: 11px;

    .new-agreements-details {

      .expand-details {
        text-decoration: underline;
      }

      .hidden-part {
        display: none;
        padding: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        background: #f0f0f0;
        text-decoration: none;
      }
    }

    .term__group {
      padding: 20px;
      background: #eaeaea;
      margin-bottom: 20px;

      .form-group {
        margin-bottom: 0px;
      }

    }

  }

  .legal-info {
    font-size: 11px;
  }

  .legal-group {
    font-size: 11px;

    small {
      font-size: 14px;
    }
  }

  .agreement_checkbox {
    margin-right: 7px;
    width: 15px;
    height: 15px;
    float: left;
    top: 2px;
    position: relative;
  }
</style>
